import {
	FETCH_PRACTICE_ALERTS,
	FETCH_PRACTICE_ALERTS_ERROR,
	SAVE_PRACTICE_ALERT,
	SAVE_PRACTICE_ALERT_ERROR,
	DELETE_PRACTICE_ALERT,
	DELETE_PRACTICE_ALERT_ERROR
} from '../ActionTypes';

const initialState = {
	latest: null,
	all: [],
	loading: false,
	error: null,
	alertText: '',
	alertAuthor: '',
};

const practiceAlertsReducers = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_PRACTICE_ALERTS:
			return {
				...state,
				loading: true,
				error: null
			};
		case SAVE_PRACTICE_ALERT:
			return {
				...state,
				latest: action.payload,
				loading: false,
				error: null,
			};
		case FETCH_PRACTICE_ALERTS_ERROR:
		case SAVE_PRACTICE_ALERT_ERROR:
		case DELETE_PRACTICE_ALERT_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload
			};
		case DELETE_PRACTICE_ALERT:
			return {
				...state,
				latest: null,
				alertText: '',
				alertAuthor: '',
				loading: false,
				error: null,
			};
		default:
			return state;
	}
};

export default practiceAlertsReducers;